import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faSignInAlt, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoginService } from '../../login/login.service';
import { User } from '../../models/user';
import { ExportFilterComponent } from '../export-filter/export-filter.component';
import { NewCourseComponent } from '../new-course/new-course.component';
import { DebugService } from 'src/app/debug.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './app-navbar.component.html',
  styleUrls: ['./app-navbar.component.scss']
})
export class AppNavbarComponent implements OnInit {
  isAdmin = false;
  isLoggedIn = false;
  currentUser: User;
  @Input() title = '';
  bsModalRef: BsModalRef;

  assignedRoles = '';
  faUser = faUser;
  faSignIn = faSignInAlt;
  faSignOut = faSignOutAlt;

  debug = false;

  constructor(private loginService: LoginService, private router: Router,
    private modalService: BsModalService,
    private debugService: DebugService) { }

  ngOnInit() {
    this.isLoggedIn = this.loginService.isLoggedIn;
    this.currentUser = this.loginService.currentUser;
    this.isAdmin = this.loginService.isAdmin;
    this.loginService.isLoggedIn$.subscribe(res => {
      this.isLoggedIn = res;
      this.isAdmin = this.loginService.isAdmin;
      this.currentUser = this.loginService.currentUser;
      this.assignedRoles = this.currentUser?.roles.map((role) => role.display_name).join(', ');
    });
    this.debugService.debugActive$.subscribe((state) => this.debug = state);
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(['/login']);
  }

  openModalWithComponent() {
    const initialState = {
      title: 'Export',
      closeBtnName: 'Abbrechen',
      keyboard: true,
    };
    this.bsModalRef = this.modalService.show(ExportFilterComponent, { class: 'modal-lg', initialState });
  }

  newCourseSelection() {
    const initialState = {
      title: 'Neuer Lehrgang',
      closeBtnName: 'Abbrechen',
      keyboard: true,
    };
    this.bsModalRef = this.modalService.show(NewCourseComponent, { initialState });
  }

}
